import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/loading'

const initialState = { loading: false }

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  switch (action.type) {
    case actionTypes.START_LOADING:
      return mergeState({ loading: true })
    case actionTypes.FINISH_LOADING:
      return mergeState({ loading: false })
    default:
      return prevState
  }
}
